import * as angular from 'angular';
import * as moment from 'pkp-moment-timezone-all-years';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpRuntimeStartNotInPastValidator
     * @memberof app
     *
     * @restrict A
     * @scope false
     *
     * @description
     * If runtime start is in the past, the value is invalid
     *
     * @attr {{start: Date, end: Date}} ngModel
     * @attr {boolean} startNotInPastValidatorActive
     *
     *
     * @author somarten.btc
     */
    angular
        .module('app')
        .directive(
            'pkpRuntimeStartNotInPastValidator',
            pkpRuntimeStartNotInPastValidator
        );

    function pkpRuntimeStartNotInPastValidator() {
        return {
            restrict: 'A',
            scope: false,
            require: 'ngModel',
            link: linkFn
        };

        function linkFn(scope, elem, attr, ngModelCtrl) {
            ngModelCtrl.$validators.pkpRuntimeStartNotInPastValidator =
                validate;

            function validate(modelValue) {
                if (!modelValue || !modelValue.start) {
                    return true;
                }

                if (
                    angular.isDefined(attr.startNotInPastValidatorActive) &&
                    !scope.$eval(attr.startNotInPastValidatorActive)
                ) {
                    return true;
                }

                var now = moment();
                var runtimeStart = moment(modelValue.start);

                return !runtimeStart.isBefore(now, 'minute');
            }
        }
    }
})();
